// extracted by mini-css-extract-plugin
module.exports = {"SimpleSearchContainer":"DealSearch_SimpleSearchContainer__pPIDY","SearchDetailContainer":"DealSearch_SearchDetailContainer__pouQ9"};